import dayjs, { Dayjs } from 'dayjs'
import UsersTechnology from '../models/UsersTechnology'
import { Option } from '../../../components/Form/Inputs/AutocompleteInput'
import DemandState from '../enums/DemandState'

export type DemandFormValues = {
  numberOfPeople: string
  technologies: UsersTechnology[]
  project: Option | null
  startDate: Dayjs | null
  submitter: Option | null
  state: DemandState
  completed: boolean
  description: string
  version: number
  vacancy: boolean
}

export const defaultDemandFormValues: DemandFormValues = {
  numberOfPeople: '1',
  technologies: [],
  project: null,
  startDate: dayjs().utc(true),
  submitter: null,
  state: DemandState.PENDING,
  completed: false,
  description: '',
  version: 1,
  vacancy: false,
}